import React, { useContext, useEffect, useState } from 'react';
import { MainContainer } from '../../components/MainContainer';
import { TableAccess } from './components/TableAccess';
import { AccessControlNames } from '../../namesConstants/names';
import { initialStateTable } from '../Invitations/const';
import { HeaderTable } from './components/HeaderTable';
import useAccess from '../../hooks/access/useAccess';
import { StoreContext } from '../../business/Provider';
import { ToolbarSearch } from './../../components/ToolbarSearch/index';

export const AccessControlScreen = () => {
	const {
		getAccessState,
		getAccessCompaniesState,
		companyState
	} = useContext(StoreContext);
	const [access, setAccess] = useState([]);
	const [accessCompaniesSelected, setAccessCompaniesSelected] = useState([]);
	const [accessCompanies, setAccessCompanies] = useState([]);
	const [filters, setFilters] = useState(initialStateTable);
	const [globalFilterValue, setGlobalFilterValue] = useState('');
	const { postAccess } =useAccess();

	useEffect(() => {
		clearTextLabel();
	}, []);

	useEffect(() => {
		if (getAccessState.loading === false &&
			getAccessState.access !== undefined &&
			getAccessState.access !== null
		) {
			const _result = getAccessState.access?.results;
			setAccess(_result);
		}
	}, [getAccessState]);

	useEffect(() => {
  if (getAccessCompaniesState.loading === false &&
    getAccessCompaniesState.accessCompanies !== undefined &&
    getAccessCompaniesState.accessCompanies !== null
  ) {
    const _resultCompanies = getAccessCompaniesState.accessCompanies?.results;

    setAccessCompanies(_resultCompanies);

    if (companyState.companies && companyState.companies.instanceId) {
      const currentCompany = _resultCompanies.find(c => c.instanceId === companyState.companies.instanceId);
      if (currentCompany !== undefined && currentCompany !== null) {
        setAccessCompaniesSelected([currentCompany]);
      }
    }
  }
}, [getAccessCompaniesState]);

	function onGlobalFilterChange(e) {
		const { value } = e.target;
		const newValue = value.replace(
			'^[a-zA-ZÀ-ÿ\u00f1\u00d1]+(s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]+$',
			' '
		);
		const _filters = { ...filters };
		_filters.global.value = newValue;
		setFilters(_filters);
		setGlobalFilterValue(newValue);
	}

	function clearTextLabel() {
		const newValue = ''.replace(
			'^[a-zA-ZÀ-ÿ\u00f1\u00d1]+(s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]+$',
			' '
		);
		const _filters = { ...filters };
		_filters.global.value = newValue;
		setGlobalFilterValue(newValue);
		setFilters(_filters);
	}

	const renderHeader = () => {
		return (
			<HeaderTable
				companies={accessCompanies}
				handleCompanySelectChange={handleCompanySelectChange}
				defaultCompany={companyState?.companies?.instanceId}
			/>
		);
	};

	const renderHeaderGrid = () => {
		return (			
			<div className='w-full flex flex-row !h-[60px]'>
				<ToolbarSearch
					onChange={onGlobalFilterChange}
					value={globalFilterValue}
					clearTextLabel={clearTextLabel}
					hidden='hidden'
				/>
			</div>
		);
	};

	const renderBodyMain = () => {
		return (
			<div className='w-full h-full flex flex-col'>				
				<TableAccess
					setAccessValue = {setAccessValue}
					list={access}
					filters={filters}
				/>
			</div>
		);
	};
	return (
		<MainContainer cancelTittle nameScreen={AccessControlNames.ScreenTitle}>
			<div className='flex w-full h-full justify-center items-center content-center relative flex-col'>
			{renderHeaderGrid()}
			{renderHeader()}
			{renderBodyMain()}
			</div>
		</MainContainer>
	);	

	async function setAccessValue(objectSend) {		
		const companyIdsString = accessCompaniesSelected
  		.map(c => c.instanceId)
  		.join(',');
		postAccess({companies:companyIdsString, access:objectSend});
	}

	async function handleCompanySelectChange(data) {
		setAccessCompaniesSelected(data); 
	}
};
